import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/pcIndex",
      name: "pcIndex",
      component: () => import("@/pages/pc/index.vue")
    },
    {
      path: "/mobileIndex",
      name: "mobileIndex",
      component: () => import("@/pages/mobile/index.vue")
    },
    {
      path: "/mobileAbout",
      name: "mobileAbout",
      component: () => import("@/pages/mobile/about.vue")
    },
    {
      path: "/mobileJiuFen",
      name: "mobileJiuFen",
      component: () => import("@/pages/mobile/jiufen.vue")
    },
    {
      path: "/mobileXieYi",
      name: "mobileXieYi",
      component: () => import("@/pages/mobile/xieyi.vue")
    },
    {
      path: "/mobileYinsi",
      name: "mobileYinsi",
      component: () => import("@/pages/mobile/yinsi.vue")
    },
    {
      path: "/pcAbout",
      name: "pcAbout",
      component: () => import("@/pages/pc/about.vue")
    },
    {
      path: "/mobileJoin",
      name: "mobileJoin",
      component: () => import("@/pages/mobile/join.vue")
    },
    {
      path: "/pcJoin",
      name: "pcJoin",
      component: () => import("@/pages/pc/join.vue")
    },
    {
      path: "/pcJiuFen",
      name: "pcJiuFen",
      component: () => import("@/pages/pc/jiufen.vue")
    },
    {
      path: "/pcXieYi",
      name: "pcXieYi",
      component: () => import("@/pages/pc/xieyi.vue")
    },
    {
      path: "/pcYinsi",
      name: "pcYinsi",
      component: () => import("@/pages/pc/yinsi.vue")
    },
    {
      path: "/mobileCooperation",
      name: "mobileCooperation",
      component: () => import("@/pages/mobile/cooperation.vue")
    },
    {
      path: "/pcCooperation",
      name: "pcCooperation",
      component: () => import("@/pages/pc/cooperation.vue")
    },
    {
      path: "/mobileIndex/recordingappgoods",
      name: "recordingappgoods",
      component: () => import("@/pages/mobile/recordingapp/goods.vue"),
      meta: {
        title: 'AI自动录音软件 | 录音转文字实现云存储',
        content: {
          description: '针对商务生活娱乐等场景提供专业的录音解决方案，更有录音转文字、云存储、智能降噪等功能满足你的编辑需求。'
        }
      }
    },
    {
      path: "/mobileIndex/recordingappmb",
      name: "recordingappmb",
      component: () => import("@/pages/mobile/recordingapp/mbrecord.vue"),
      meta: {
        title: '一键专业录音 | 重要内容清晰记录',
        content: {
          description: '针对商务生活娱乐等场景提供专业的录音解决方案，更有录音转文字、云存储、智能降噪等功能满足你的编辑需求。'
        }
      }
    },
    {
      path: "/mobileIndex/recordingapporder",
      name: "recordingapporder",
      component: () => import("@/pages/mobile/recordingapp/order.vue")
    },
    {
      path: "/mobileIndex/yuyuexuzhi",
      name: "yuyuexuzhi",
      component: () => import("@/pages/mobile/recordingapp/xuzhi.vue")
    },
    {
      path: "/mobileIndex/recordingapppay",
      name: "recordingapppay",
      component: () => import("@/pages/mobile/recordingapp/pay.vue")
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js